import { type FC, useMemo } from 'react';
import { InputToggleGroup, type InputToggleGroupProps } from '@components/InputToggleGroup';
import { getToggleGroupOptions } from '@components/shared';
import { useDatapointsStore } from '@ContractBuilder/store/datapoints.store';
import { datapointFieldSelector } from '@ContractBuilder/utils/datapoint-field-selector';
import type { JSONSchemaEnum, JSONSchemaProperties } from '@root/@types/types';

interface InputToggleGroupSchemaProps extends InputToggleGroupProps {
  item: {
    helperText?: string;
    shortName?: string;
    enum: JSONSchemaEnum[];
  };
  ownKey: string;
}

const InputToggleGroupSchema: FC<InputToggleGroupSchemaProps> = (props) => {
  const { item, ownKey, errors, isRequired } = props;
  const selector = useMemo(() => datapointFieldSelector({ ownKey, isRequired, errors }), [ownKey, isRequired, errors]);

  const { value, isIncomplete } = useDatapointsStore(selector);

  return (
    <InputToggleGroup
      {...props}
      value={value}
      isIncomplete={isIncomplete}
      options={getToggleGroupOptions(item as JSONSchemaProperties)}
    />
  );
};

export default InputToggleGroupSchema;
